/* eslint-disable eslint-comments/disable-enable-pair -- needed */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types -- needed */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardContent, CardLayout, CardMedia,
} from '@americanexpress/dls-react';

const GridLayout = ({ children }) => {
  if (!children) {
    throw new Error('This layout expects children');
  }

  return (
    <Card
      orientation="vertical"
      className="height-full"
      innerContainerClassName="pad-0"
      data-testid="view-all-tile"
    >
      <CardMedia className="no-scroll">
        {children[0]}
      </CardMedia>
      <CardLayout>
        <CardContent className="pad-0-t pad-0-b">
          <div data-testid="body" id="body" className="pad-0">
            {children[1]}
            {children[2]}
          </div>
          <div>
            {children[3]}
            {children[4]}
            {children[5]}
          </div>
        </CardContent>
      </CardLayout>
    </Card>
  );
};

GridLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array,
  ]).isRequired,
};

export default GridLayout;
